import { combineReducers } from 'redux';

import InvoiceTypes from './types';

export const invoiceReducer = combineReducers({
  invoice: InvoiceTypes.loadInvoice.getReducer(),
  listStatus: InvoiceTypes.listInvoiceStatus.getReducer(),
  refundInvoice: InvoiceTypes.refundInvoice.getReducer(),
  items: InvoiceTypes.listInvoiceItems.getReducer(),
  history: InvoiceTypes.loadInvoiceHistory.getReducer(),
  addAffiliate: InvoiceTypes.addAffiliateInvoice.getReducer(),
  access: InvoiceTypes.loadProductAccess.getReducer(),
  loadProductHistoryAccess: InvoiceTypes.loadProductHistoryAccess.getReducer(),
  sendBoleto: InvoiceTypes.sendBoleto.getReducer(),
  delivery: InvoiceTypes.delivery.getReducer(),
  loadPins: InvoiceTypes.loadListPins.getReducer(),
  partialRefundInvoice: InvoiceTypes.partialRefundInvoice.getReducer(),
});
